// import React, { useState } from 'react';
// import './App.css';
// import MapaSVG from './components/MapaSVG';
// import Buscador from './components/Buscador';
// import SelectorPabellon from './components/SelectorPabellon';
// import data from './data/expositores.json';

// function App() {
//   const [pabellonSeleccionado, setPabellonSeleccionado] = useState(null);
//   const [expositorBuscado, setExpositorBuscado] = useState('');
//   const [infoExpositor, setInfoExpositor] = useState(null);

//  const handleBuscar = (terminoBusqueda) => {
//   const nombreNormalizado = terminoBusqueda
//     .toLowerCase()
//     .normalize("NFD")
//     .replace(/[\u0300-\u036f]/g, "");

//   // Buscar el expositor por clave
//   const expositorKey = Object.keys(data).find((key) =>
//     key.toLowerCase()
//       .normalize("NFD")
//       .replace(/[\u0300-\u036f]/g, "") === nombreNormalizado
//   );

//   if (expositorKey) {
//     const expositor = data[expositorKey];
//     setPabellonSeleccionado(expositor.pabellon.toLowerCase());
//     setInfoExpositor({ nombre: expositorKey, ...expositor });

//     setTimeout(() => {
//       const elemento = document.getElementById(expositor.id);
//       if (elemento) {
//         elemento.classList.add("resaltado");
//         elemento.scrollIntoView({ behavior: "smooth", block: "center" });
//       }
//     }, 500);
//   } else {
//     alert("Expositor no encontrado.");
//     setInfoExpositor(null); 
//   }
// };

//   return (
//     <div className="App">
//       <h1>Mapa Interactivo Colombiamoda 2025</h1>
//       <SelectorPabellon setPabellonSeleccionado={setPabellonSeleccionado} />
//       <Buscador onBuscar={handleBuscar} />
//       <MapaSVG
//         pabellonSeleccionado={pabellonSeleccionado}
//         expositorBuscado={expositorBuscado}
//       />
//     </div>
//   );
// }

// export default App;

import React, { useState, useEffect } from 'react';
import './App.css';
import MapaSVG from './components/MapaSVG';
import Buscador from './components/Buscador';
import SelectorPabellon from './components/SelectorPabellon';

function App() {
  const [pabellonSeleccionado, setPabellonSeleccionado] = useState(null);
  const [expositorBuscado, setExpositorBuscado] = useState('');
  const [infoExpositor, setInfoExpositor] = useState(null);
  const [data, setData] = useState({});

  // Cargar JSON dinámicamente
  useEffect(() => {
    fetch('/Colombiamoda/expositores.json')
      .then((res) => res.json())
      .then((json) => setData(json))
      .catch((err) => console.error('Error al cargar expositores.json:', err));
  }, []);

  const handleBuscar = (terminoBusqueda) => {
    const nombreNormalizado = terminoBusqueda
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

    const expositorKey = Object.keys(data).find((key) =>
      key.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") === nombreNormalizado
    );

    if (expositorKey) {
      const expositor = data[expositorKey];
      setPabellonSeleccionado(expositor.pabellon.toLowerCase());
      setInfoExpositor({ nombre: expositorKey, ...expositor });

      setTimeout(() => {
        const elemento = document.getElementById(expositor.id);
        if (elemento) {
          elemento.classList.add("resaltado");
          elemento.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 500);
    } else {
      alert("Expositor no encontrado.");
      setInfoExpositor(null);
    }
  };

  return (
    <div className="App">
      <h1>Mapa Interactivo Colombiamoda 2025</h1>
      <SelectorPabellon setPabellonSeleccionado={setPabellonSeleccionado} />
      <Buscador onBuscar={handleBuscar} />
      <MapaSVG
        pabellonSeleccionado={pabellonSeleccionado}
        expositorBuscado={expositorBuscado}
      />
    </div>
  );
}

export default App;
